// Packages
import React from "react";

// Components
import useComponents from "../../../components";

// Controllers
import useControllers from "../../../../controllers";

const RolesCreate = () => {
  const { useScreenHooks } = useControllers();
  const { useRoles } = useScreenHooks();
  const { useRolesCreate } = useRoles();
  const {
    control,
    handleSubmit,
    onSubmit,
    showModal,
    handleCloseModal,
    groupedPermissions,
  } = useRolesCreate();

  const {
    ContentWrappers,
    useButtons,
    TextFieldControlled,
    Typography,
    useModals,
    HierarchicalPermissionsGroup,
    FormLabel,
  } = useComponents();

  const { DefaultModal } = useModals();
  const { DefaultButton } = useButtons();

  return (
    <div className="bg-white px-16 pt-10 pb-12 mx-24 rounded-lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <ContentWrappers
          gridColums={["1fr"]}
          gap={{
            row: "0px",
            column: "4%",
          }}
        >
          <TextFieldControlled
            type="text"
            id="abi-role-name"
            control={control}
            label="Nombre del Rol"
            placeholder="Nombre del Rol"
            name="name"
          />
        </ContentWrappers>
        <FormLabel label="Permisos" />
        <HierarchicalPermissionsGroup
          groupedPermissions={groupedPermissions}
          control={control}
          name="permissions"
        />
        <div className="text-center mt-8">
          <DefaultButton color="secondary" type="submit">
            Crear Rol
          </DefaultButton>
        </div>
      </form>
      <DefaultModal isOpen={showModal}>
        <div className="flex items-center flex-col space-y-8">
          <Typography variant="body2">El rol ha sido creado con éxito</Typography>
          <DefaultButton color="success" onClick={handleCloseModal}>
            Aceptar
          </DefaultButton>
        </div>
      </DefaultModal>
    </div>
  );
};

export default RolesCreate;
